import PagePanel from "../../core/App/PagePanel";
import { RequireAuth, UserRole } from 'legoland-sdk/dist/experimental';
import { useMemo, useState } from 'react';
import { Alert, Box, Button, Heading, Text, useToasts } from 'tombac';
import { AddIcon } from 'tombac-icons';
import { useUpdateContractProductSharedLimitMutation } from "../contractsApiHooks";
import { LimitsConfiguratorModal } from "./LimitsConfiguratorModal";
import { SharedLimitsSummary } from "./SharedLimitsSummary";
import { sharedLimitSchemas } from "./sharedLimitSchemas";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function useExistingProductLimitNames(productLimitQueries) {
  return useMemo(() => {
    const productLimits = productLimitQueries.reduce((combined, query) => Object.assign(combined, query.data?.limits), {});
    return sharedLimitSchemas.filter(({
      name
    }) => productLimits[name] !== null && productLimits[name] !== undefined).map(schema => schema.name);
  }, [...productLimitQueries, sharedLimitSchemas]);
}
export const ContractProductPackages = ({
  children,
  sharedLimitsPackage,
  contractId,
  isPackageExists,
  packagedProducts: productLimitQueries
}) => {
  const {
    addToast
  } = useToasts();
  const sharedLimits = sharedLimitsPackage?.limits;
  const {
    mutateAsync: updateContractProductSharedLimits
  } = useUpdateContractProductSharedLimitMutation();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const existingProductLimits = useExistingProductLimitNames(productLimitQueries);
  const [isOverwritingLimits, setIsOverwritingLimits] = useState(false);
  const handleChange = formikContext => {
    let overwriting = false;
    for (const existingName of existingProductLimits) {
      if (formikContext.values[existingName] !== null && formikContext.values[existingName] !== undefined) {
        overwriting = true;
      }
    }
    if (overwriting !== isOverwritingLimits) {
      setIsOverwritingLimits(overwriting);
    }
  };
  const handleSubmit = async limits => {
    try {
      await updateContractProductSharedLimits({
        contractId: contractId,
        limits: {
          limits
        }
      });
      setIsEditOpen(false);
      addToast('Limits are set', 'success');
    } catch (error) {
      console.error(error);
      addToast('Could not save shared limits.', 'danger', {
        content: 'Please try again later or contact MOVE support.'
      });
    }
  };
  return /*#__PURE__*/_jsxs(Box, {
    $mb: "4sp",
    "data-sentry-element": "Box",
    "data-sentry-component": "ContractProductPackages",
    "data-sentry-source-file": "ContractProductPackages.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      $alignItems: "center",
      $display: "flex",
      $mb: "2sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "ContractProductPackages.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        level: 5,
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "ContractProductPackages.tsx",
        "data-sentry-element": "Heading",
        children: "Packages"
      }), !isPackageExists && /*#__PURE__*/_jsx(RequireAuth, {
        role: [UserRole.Admin, UserRole.Distributor],
        children: /*#__PURE__*/_jsx(Button, {
          $ml: "auto",
          onClick: () => setIsEditOpen(true),
          prepend: /*#__PURE__*/_jsx(AddIcon, {}),
          size: "xs",
          variant: "flat",
          children: "Add TS + OD package"
        })
      })]
    }), /*#__PURE__*/_jsxs(PagePanel, {
      $margin: "0",
      breakpoint: 0,
      "data-sentry-element": "PagePanel",
      "data-sentry-source-file": "ContractProductPackages.tsx",
      "data-sentry-element": "PagePanel",
      children: [/*#__PURE__*/_jsx(Box, {
        "data-sentry-element": "Box",
        "data-sentry-source-file": "ContractProductPackages.tsx",
        "data-sentry-element": "Box",
        children: isPackageExists ? /*#__PURE__*/_jsxs(Box, {
          $display: "flex",
          $flexDirection: "column",
          $gap: "5sp",
          className: "ProductList",
          children: [children, /*#__PURE__*/_jsx(SharedLimitsSummary, {
            productLimits: productLimitQueries,
            sharedLimitsPackage: sharedLimitsPackage,
            onRequestEditOpen: () => setIsEditOpen(true),
            contractId: contractId
          })]
        }) : /*#__PURE__*/_jsx(Text, {
          fontSize: 12,
          variant: "secondary",
          children: "No package had been added."
        })
      }), /*#__PURE__*/_jsx(LimitsConfiguratorModal, {
        append: isOverwritingLimits && /*#__PURE__*/_jsx(Alert, {
          title: "Changing existing limits",
          variant: "alert",
          children: "Any previously set limits will be overwritten."
        }),
        isOpen: isEditOpen,
        limits: sharedLimits ?? {},
        onChange: handleChange,
        onRequestClose: () => setIsEditOpen(false),
        onSubmit: handleSubmit,
        schemas: sharedLimitSchemas,
        "data-sentry-element": "LimitsConfiguratorModal",
        "data-sentry-source-file": "ContractProductPackages.tsx",
        "data-sentry-element": "LimitsConfiguratorModal"
      })]
    })]
  });
};